import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import ToggleButton from '@material-ui/lab/ToggleButton'
import { CentricTypography } from '@core/component/CentricTypography'
import { makeStyles } from '@material-ui/core'
import classNames from 'classnames'

const useStyle = makeStyles(theme => ({
  toggleGroup: {
    display: 'flex',
    justifyContent: 'center',
    border: '1px Solid #EEE',
    borderRadius: '4px',
    height: 24,
    alignItems: 'center',
    boxShadow: 'none',
    '& .Mui-selected': {
      boxShadow: 'none'
    },
    '& button:hover': {
      backgroundColor: 'transparent'
    },
    '& .Mui-selected:hover': {
      backgroundColor: '#EEE'
    }
  },
  toggleSwitchBtn: {
    width: 64,
    border: 'none',
    padding: 4
  },
  checkedSwitch: {
    backgroundColor: '#EEE'
  },
  disabledSwitch: {
    pointerEvents: 'none',
    opacity: 0.7,
    cursor: 'not-allowed'
  }
}))

export default function EnhancedQuantitySwitch({
  onChange,
  checked = false,
  disabled
}): JSX.Element {
  return useObserver(function useHook() {
    const { t } = useTranslation()
    const classes = useStyle()
    return (
      <>
        <ToggleButtonGroup
          value={checked}
          exclusive
          className={classNames(classes.toggleGroup, {
            [classes.disabledSwitch]: disabled
          })}
          size={'small'}
          onClick={event => {
            onChange(event, !checked)
          }}
        >
          <ToggleButton
            value={false}
            className={classNames(classes.toggleSwitchBtn, {
              [classes.checkedSwitch]: !checked
            })}
            disabled={disabled}
            size='small'
          >
            <CentricTypography variant={disabled ? 'captionGrey' : 'caption'}>
              {t('common.label.quantity', 'Quantity')}
            </CentricTypography>
          </ToggleButton>
          <ToggleButton
            value={true}
            className={classNames(classes.toggleSwitchBtn, {
              [classes.checkedSwitch]: checked
            })}
            disabled={disabled}
            size='small'
          >
            <CentricTypography variant={disabled ? 'captionGrey' : 'caption'}>
              {t('common.label.value', 'Value')}
            </CentricTypography>
          </ToggleButton>
        </ToggleButtonGroup>
      </>
    )
  })
}
